import { useTranslation } from 'next-i18next'
// Dependencies.
import styled from 'styled-components'
import { useState, useContext } from 'react'

import { H1 } from '../H1'
import { P } from '../P'
import { FormField } from '../Inputs/FormField'
import { Input } from '../Inputs/Input'
import { CTA } from '../CTA'
import { UserContext } from '../../context'
import { ValidationWrapper } from '../Inputs/ValidationWrapper'

// Div.
const Form = styled.form`
  margin: auto;
  max-width: 90%;
  text-align: center;
  width: 492px;

  .header {
    margin-bottom: 18px;
  }

  .subheader {
    margin-bottom: 30px;
  }

  .formField {
    text-align: left;
  }

  .sentFeedback {
    margin-top: 60px;
  }

  .CTA {
    margin-top: 60px;
  }
`

// Props.
interface Props {}

// Forgot Password Form.
export const ForgotPasswordForm: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // User.
  const { recoverPasswordWithEmail } = useContext(UserContext)

  // State.
  const [error, setError] = useState('')
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  // On Submit.
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      // Prevent Default.
      event.preventDefault()

      // Clear Errors.
      setError('')

      // Flag Loading.
      setLoading(true)

      // Reset Password.
      await recoverPasswordWithEmail(email)

      // Flag Sent.
      setSent(true)
    } catch (error) {
      const { status } = error.response
      if (status === 404) setError(t('Email not found.', 'Email not found.'))
      else setError(t(`An error occurred.`, `An error occurred.`))
    }

    // Unflag Loading.
    setLoading(false)
  }

  // ..
  return (
    <Form className="forgotPasswordForm" onSubmit={onSubmit}>
      {/* Header. */}
      <H1 className="header">{t(`Forgot password`, `Forgot password`)}</H1>

      {/* Subheader. */}
      {!sent && (
        <P className="subheader">
          {t(
            `ForgotPasswordForm400726963`,
            `Enter the email you used to sign up below and we’ll send you a link to reset your password`,
          )}
        </P>
      )}

      {/* Email Field. */}
      {(!sent && (
        <FormField
          className="emailField"
          required
          title={t(`Enter your email`, `Enter your email`)}>
          {/* Validation Wrapper. */}
          <ValidationWrapper error={error}>
            <Input
              disabled={loading}
              onChange={(e) => {
                if (error) setError('')
                setEmail(e.target.value)
              }}
              placeholder={t(`Email`, `Email`)}
              type="email"
              value={email}
            />
          </ValidationWrapper>
        </FormField>
      )) || (
        <P className="sentFeedback">
          {t(`ForgotPasswordForm1424739765`, `A reset link has been sent to `)}
          {email}
          <br />
          {t(`ForgotPasswordForm995117235`, `Check your inbox for more info`)}
        </P>
      )}

      {/* Send Button. */}
      {!sent && (
        <CTA className="CTA purple" disabled={loading}>
          {t(`ForgotPasswordForm745457634`, `Send link`)}
        </CTA>
      )}
    </Form>
  )
}
